import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-version',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `{{ version }}`
})
export class VersionComponent implements OnInit {
  version = environment.versions.app;
  constructor() {}

  ngOnInit(): void {}
}
